import { vodStateType } from "../store";

const vod = {
  namespace: true,
  state: {
    render: false,
  } as vodStateType,
  getters: {
    showRender: (state: vodStateType) => {
      return state.render;
    },
  },
  mutations: {
    set_render(state: vodStateType, data: boolean) {
      state.render = data;
    },
    // 重置 state 为默认值（退出登录时使用）
    resetState(state: vodStateType) {
      state.render = false;
    },
  },
};

export default vod;
